import type {FC} from 'react'
import {useEffect, useState} from 'react'
import {FormikErrors} from 'formik'
import {EditorState} from 'draft-js'
import {stateToHTML} from 'draft-js-export-html'
import {Editor} from 'react-draft-wysiwyg'
import {ModalDefault} from '../../ui'
import htmlToEditorState from '../../../utils/htmlToEditorState'

interface Desc {
  name: string
  value: string
}

interface Props {
  descriptionState: [Desc, React.Dispatch<React.SetStateAction<Desc>>]
  setValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => Promise<FormikErrors<any>> | Promise<void>
}

const ModalRichEditor: FC<Props> = ({descriptionState, setValue}) => {
  const [description, setDescription] = descriptionState
  const [editorState, setEditorState] = useState<EditorState>(EditorState.createEmpty())

  useEffect(() => {
    if (description.value) {
      setEditorState(htmlToEditorState(description.value))
    }
  }, [description.value])

  useEffect(() => {
    document.getElementById('modal-rich-editor')?.addEventListener('hidden.bs.modal', () => {
      setEditorState(EditorState.createEmpty())
      setDescription({name: '', value: ''})
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <ModalDefault id='modal-rich-editor' size='xl' title='Description' hides={['footer']}>
      <div className='col'>
        <h4 className='fs-24'>Description</h4>
        <Editor
          editorState={editorState}
          toolbarClassName='toolbarClassName'
          wrapperClassName='wrapperClassName'
          editorClassName='editorClassName'
          onEditorStateChange={setEditorState}
        />
        <div className='d-flex justify-content-end gap-4'>
          <button type='button' id='close-modal' className='btn btn-light' data-bs-dismiss='modal'>
            Cancel
          </button>
          <button
            onClick={() => setValue(description.name, stateToHTML(editorState.getCurrentContent()))}
            type='button'
            className='btn btn-primary'
            data-bs-dismiss='modal'
          >
            Submit
          </button>
        </div>
      </div>
    </ModalDefault>
  )
}

export default ModalRichEditor
